/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
      $("#close-area, #country-text").on("click", function() {
        $(".country_redirect_banner").remove();
      });

     $('.Choose_location, .footer_location_menu').on('click', function () {
        $('.country-side-drawer, .country_overlay').addClass('active');
    });

    $('.country-side-drawer, .close-btn').on('click', function () {
        $('.country-side-drawer, .country_overlay').removeClass('active');
    });
  
   
       $('a.Header__Icon.Header_Cart_Icon.Icon-Wrapper.Icon-Wrapper--clickable').on('click', function() {
        $('.PageOverlay').toggleClass('show-more');
    });    
    
     $('.PageOverlay').on('click', function() {
        $(this).removeClass('show-more');
    }); 

     $('.Drawer__Close.Icon-Wrapper--clickable').on('click', function() {
        $('.PageOverlay').removeClass('show-more');
    });
    

    //remove Notify Me button on any page besides PDP
    if (!window.location.href.includes('/products/')) {
        try {
            var notifyMeButton = $('.klaviyo-bis-trigger');
            notifyMeButton.parent().removeAttr('type').attr('type', 'button').attr('disabled', 'disabled');
            notifyMeButton.parent().html('Sold Out');
        }
        catch (e) { }

        setInterval(function () {
            $('.klav-popup-trigger').hide();
        }, 100);
    }

    //  letter count 

    function updateCharacterCount() {
        var textarea = document.getElementById('cart-note');
        var letterCount = document.getElementById('letter-count');
        var maxLength = 200; // Set the maximum length directly

        var remaining = maxLength - textarea.value.length;
        letterCount.textContent = `(${remaining}) character(s) remaining`;
        if (remaining < 1) {
            // $(this).prop('disabled', true);
            $('#letter-count').css('color', 'red');
        }
        else {
            $('#letter-count').css('color', '#1a1a1a');
        }
    }
    // Initial count update
    if ($("#cart-note").length > 0 && $("#letter-count").length > 0) {
        updateCharacterCount();
    }

    $(document).on('click', '.frangrance-section', function (e) {
        $('#frangance_pop_area').fadeIn();  // Use fadeIn to show the popup
        if ($(".frangance_popup-content.allowOne.allowTwo").length > 0) {
            if ($(".allowTwo .added.faded").length < 2) {
                $(".allowTwo .faded").removeClass("faded");
            }
        }
    });

    $(document).on('click', '#purchase_gift', function (e) {
        $('#gift_with_pop_area').fadeIn();  // Use fadeIn to show the popup
    });

    $(document).on('click', '#gift-section', function (e) {
        $('#gift_pop_area').fadeIn();  // Use fadeIn to show the popup
    });


    $(document).on('click', '.popupCloser', function (e) {
        $('.cartPopup').fadeOut();
    });

    $(document).on('input', '#cart-note', function () {

        var textarea = document.getElementById('cart-note');
        var letterCount = document.getElementById('letter-count');
        var maxLength = 200; // Set the maximum length directly
        var remaining = maxLength - textarea.value.length;
        letterCount.textContent = `(${remaining}) character(s) remaining`;
        if (remaining < 1) {
            // $(this).prop('disabled', true);
            $('#letter-count').css('color', 'red');
        }
        else {
            $('#letter-count').css('color', '#1a1a1a');
        }
    })

    $(document).on('click', '.btn.quickAddToCartBtn', function (e) {
        var selectedVariantId = $(this).attr("data-variantId");
        console.log("selectedVariantId: " + selectedVariantId);

        var finalProdForCart = [{
            id: selectedVariantId,
            quantity: 1,
        }];

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: JSON.stringify({ items: finalProdForCart }),
            contentType: "application/json",
            dataType: "json",
            success: function () {
                // Instantiate CartSection and call its methods on success
                console.log("Product added to cart successfully");

                // Now, fetch the HTML content of pages/faqs and get the div with id #sidebar-cart
                $.ajax({
                    type: "GET",
                    url: "/search",
                    success: function (response) {
                        // Create a temporary element to hold the response HTML
                        var tempElement = $('<div>').html(response);
                        // Find the div with id #sidebar-cart in the temporary element
                        var sidebarCartHtml = tempElement.find("#sidebar-cart").html();
                        console.log("HTML content of #sidebar-cart:", sidebarCartHtml);

                        $("div#sidebar-cart").html(sidebarCartHtml);


                        // Now you can use sidebarCartHtml as needed
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log("Error fetching HTML content of #sidebar-cart:", textStatus, errorThrown);
                    }
                });
            },
            error: function () {
                alert("Please Try Again..");
                console.log("ERROR");
            }
        });
    });

    $(document).on('click', '.wrapingBtn', function () {
        var $this = $(this);
        if ($(".allowGift").length > 0) {
            $(".wrapingBtn").not($this).removeClass("active willAddGift");
            $(".Prod_with_purchase").not($this.parent(".Prod_with_purchase")).removeClass("added");
            $(this).toggleClass("active willAddGift");
            $(this).parent(".Prod_with_purchase").toggleClass("added");
            if ($this.hasClass("active")) {
                $(".wrapingBtn").parent(".Prod_with_purchase").addClass("faded");
            }
            else {
                $(".Prod_with_purchase").removeClass("faded");
            }
        }
    });

    // gift items appending code start 

    $(document).on('click', '.confirmGiftBtn', function () {
        addGiftItemInCart();
        $('.cartPopup').fadeOut();
    });


    function addGiftItemInCart() {
        localStorage.removeItem('cartGiftItems');
        $('#cartFreeGiftArea').empty();
        $("button.wrapingBtn.active.willAddGift").each(function () {
            var imgUrl = $(this).attr('data-img');
            var prodName = $(this).attr('data-prodname');
            var variantId = $(this).attr('data-variantid');
            var variantQty = $(this).attr('data-qty');
            var parentItemId = $(this).parent(".Prod_with_purchase").attr('id');
            var cartItemHtml = $(".appendCartGift").html();

            cartItemHtml = cartItemHtml.replace('%imgUrl%', imgUrl);
            cartItemHtml = cartItemHtml.replace('%prodName%', prodName);
            cartItemHtml = cartItemHtml.replace('%prodId%', variantId);
            cartItemHtml = cartItemHtml.replace('%prodPrice%', 'Free');
            cartItemHtml = cartItemHtml.replace('%prodQty%', variantQty);
            cartItemHtml = cartItemHtml.replace('%addedItemId%', `#${parentItemId}`);
            cartItemHtml = cartItemHtml.replace('%variantId%', variantId);
            $('#cartFreeGiftArea').append(cartItemHtml);
            var localStorageContent = $('#cartFreeGiftArea').html();
            localStorage.setItem('cartGiftItems', localStorageContent);
            saveGiftItemsClasses();
        });
    }

    function saveGiftItemsClasses() {
        localStorage.removeItem('giftItemClasses');
        var items = [];
        $('.Prod_with_purchase').each(function () {
            var item = {
                id: $(this).attr('id'),
                classes: $(this).attr('class')
            };
            items.push(item);
        });
        localStorage.setItem('giftItemClasses', JSON.stringify(items));
    }


    $(document).on('click', 'button.removeGiftBtn', function () {
        var mainItemContainer = $(this).attr("data-id");
        var removedItem = $(this).closest(".appendedCartItem");
        $(removedItem).remove();
        $(mainItemContainer).removeClass("added");
        $(mainItemContainer).find(".wrapingBtn").removeClass("active").removeClass("willAddGift");
        $('.Prod_with_purchase').removeClass("faded");

        localStorage.removeItem('cartGiftItems');
        var localStorageContent = $('#cartFreeGiftArea').html();
        localStorage.setItem('cartGiftItems', localStorageContent);
        saveGiftItemsClasses();
    });


    // smart items appending code start 

    $(document).on('click', '.confirmSmartItems', function () {
        addSmartItemsIntoCart();
        $('.cartPopup').fadeOut();
    });


    $(document).on('click', 'button.smartItemBtn', function () {
        var $this = $(this);
        var $activeWillAdd = $(".active.willAdd");
        var allowTwo = $(".frangance_popup-content.allowTwo").length > 0;
        var allowOne = $(".frangance_popup-content.allowOne").length > 0;

        if (allowTwo) {
            if ($activeWillAdd.length >= 2 && !$this.hasClass("active")) {
                // If there are already 2 active items and the clicked item is not active, do nothing
                return;
            } else {
                $this.toggleClass("active willAdd");
                $this.parent($('.inner_item')).toggleClass("added");

                // Update the count after the toggle
                $activeWillAdd = $(".active.willAdd");

                if ($activeWillAdd.length >= 2) {
                    // If there are now 2 active items, add the faded class to the rest
                    $('.inner_item').addClass("faded");
                } else {
                    // If less than 2 active items, remove the faded class
                    $('.inner_item').removeClass("faded");
                }
            }
        } else if (allowOne) {
            if ($activeWillAdd.length >= 1 && $this.hasClass("active")) {
                // Remove classes from the currently active item if there's already one
                $('.inner_item').removeClass("faded");
                $this.parent($('.inner_item')).removeClass("added");
                $activeWillAdd.removeClass("active willAdd");
            }
            else {
                $this.toggleClass("active willAdd");
                $this.parent($('.inner_item')).toggleClass("added");
                $('.inner_item').addClass("faded");
            }
        } else {
            // If neither allowOne nor allowTwo, simply toggle the classes
            $this.removeClass("active willAdd");
            $('.inner_item').removeClass("added");
            $('.inner_item').removeClass("faded");
        }
    });


    function addSmartItemsIntoCart() {
        localStorage.removeItem('cartSmartItems');
        $('#cartSmartItemsAppendedArea').empty();
        $("button.smartItemBtn.active.willAdd").each(function () {
            var imgUrl = $(this).attr('data-img');
            var prodName = $(this).attr('data-prodname');
            var variantId = $(this).attr('data-variantid');
            var variantQty = $(this).attr('data-qty');
            var parentItemId = $(this).parent(".inner_item").attr('id');
            var cartItemHtml = $(".appendCartSampleHtml").html();
            console.log(imgUrl);
            console.log(prodName);
            cartItemHtml = cartItemHtml.replace('%imgUrl%', imgUrl);
            cartItemHtml = cartItemHtml.replace('%prodName%', prodName);
            cartItemHtml = cartItemHtml.replace('%prodId%', variantId);
            cartItemHtml = cartItemHtml.replace('%prodPrice%', 'Free');
            cartItemHtml = cartItemHtml.replace('%prodQty%', variantQty);
            cartItemHtml = cartItemHtml.replace('%addedItemId%', `#${parentItemId}`);
            cartItemHtml = cartItemHtml.replace('%variantId%', variantId);
            $('#cartSmartItemsAppendedArea').append(cartItemHtml);
            var localStorageContent = $('#cartSmartItemsAppendedArea').html();
            localStorage.setItem('cartSmartItems', localStorageContent);
            saveSmartItemsClasses();
        });
    }


    var dropDownBtnsClick = 0;
    $(document).on('click', '.boost-pfs-filter-option button.boost-pfs-filter-button', function () {
        if (dropDownBtnsClick > 3) {
            $(".boost-pfs-filter-option").not($(this).parent(".boost-pfs-filter-option-title").parent(".boost-pfs-filter-option")).addClass("boost-pfs-filter-option-collapsed");
        }
        dropDownBtnsClick = dropDownBtnsClick + 1;
    });


    $(document).on('click', 'button.removeSmartItemBtn', function () {
        var mainItemContainer = $(this).attr("data-id");
        var removedItem = $(this).closest(".appendedCartItem");
        $(removedItem).remove();
        $(mainItemContainer).removeClass("added");
        $(mainItemContainer).find(".smartItemBtn").removeClass("active").removeClass("willAdd");
        $('.inner_item').removeClass("faded");

        localStorage.removeItem('cartSmartItems');
        var localStorageContent = $('#cartSmartItemsAppendedArea').html();
        localStorage.setItem('cartSmartItems', localStorageContent);
        saveSmartItemsClasses();
    });

    function saveSmartItemsClasses() {
        localStorage.removeItem('smartItemsClasses');
        var items = [];
        $('.fragance_item  .inner_item').each(function () {
            var item = {
                id: $(this).attr('id'),
                classes: $(this).attr('class')
            };
            items.push(item);
        });
        localStorage.setItem('smartItemsClasses', JSON.stringify(items));
    }
    // smart items appending code end


    $(document).on('click', '.addWrapAndCheckout', function () {
        $(this).addClass("disabledBtn");
        var finalProdForCart = [];
        if ($(".gifWrapBtn").hasClass("active") || $("#cartFreeGiftArea .appendedCartItem").length > 0 || $("#cartSmartItemsAppendedArea .appendedCartItem").length > 0) {


            if ($("#cartFreeGiftArea .appendedCartItem").length > 0) {
                $("#cartFreeGiftArea .appendedCartItem").each(function () {
                    var smartProdVariantId = $(this).find(".cartItemQty").attr("data-variant-id");
                    var smartProdVariantQty = parseInt($(this).find(".cartItemQty").attr("value"));
                    finalProdForCart.push({
                        id: smartProdVariantId,
                        quantity: smartProdVariantQty,
                        properties: {
                            "_freeProd": "true"
                        }
                    });
                });
            }


            if ($("#cartSmartItemsAppendedArea .appendedCartItem").length > 0) {
                $("#cartSmartItemsAppendedArea .appendedCartItem").each(function () {
                    var smartProdVariantId = $(this).find(".cartItemQty").attr("data-variant-id");
                    var smartProdVariantQty = parseInt($(this).find(".cartItemQty").attr("value"));
                    finalProdForCart.push({
                        id: smartProdVariantId,
                        quantity: smartProdVariantQty,
                        properties: {
                            "_freeProd": "true"
                        }
                    });
                });
            }

            if (finalProdForCart.length > 0) {
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: { items: finalProdForCart },
                    dataType: "json",
                    success: function () {
                        localStorage.setItem('checkout', 'true');
                        window.location.href = "/checkout";
                        $(this).removeClass("disabledBtn");
                    },
                    error: function () {
                        console.log("ERROR");
                        window.location.href = "/checkout";
                        $(this).removeClass("disabledBtn");
                    }
                });
            }
            else {
                window.location.href = "/checkout";
                $(this).removeClass("disabledBtn");
            }
        }
        else {
            window.location.href = "/checkout";
            $(this).removeClass("disabledBtn");
        }
    });


       function appendItemsOnLoad() {
        if ($(".frangances_smaples_area").length > 0 && $(".allowOne").length > 0) {
            var cartItemHtml = localStorage.getItem('cartSmartItems');
            if (cartItemHtml) {
                $('#cartSmartItemsAppendedArea').append(cartItemHtml);
            }
            var smartItemsClasses = localStorage.getItem('smartItemsClasses');
            if (smartItemsClasses) {
                smartItemsClasses = JSON.parse(smartItemsClasses);
                smartItemsClasses.forEach(function (item) {
                    var element = $('#' + item.id);
                    if (element.length) {
                        element.attr('class', item.classes);
                        if (item.classes.includes('added')) {
                            element.find('.smartItemBtn').addClass("active willAdd");
                        }
                    }
                });
            }
        }
        else {
            localStorage.removeItem('cartSmartItems');
            localStorage.removeItem('smartItemsClasses');
        }


        if ($(".purchase_gift_area.allowGift").length > 0) {
            var cartItemHtml = localStorage.getItem('cartGiftItems');
            if (cartItemHtml) {
                $('#cartFreeGiftArea').append(cartItemHtml);
            }
            var giftItemClasses = localStorage.getItem('giftItemClasses');
            if (giftItemClasses) {
                giftItemClasses = JSON.parse(giftItemClasses);
                giftItemClasses.forEach(function (item) {
                    var element = $('#' + item.id);
                    if (element.length) {
                        element.attr('class', item.classes);
                        if (item.classes.includes('added')) {
                            element.find('.wrapingBtn').addClass("active willAddGift");
                          // Existing: premium
                    if ($(".purchase_gift_area.allowGiftTwo").length > 0) {
                        $(".wrapingBtn.premiumGift").addClass(
                        "active willAddPremiumGift"
                        );
                    }
                         if ($(".purchase_gift_area.allowGiftThree").length > 0) {
                        $(".wrapingBtn.ultraGift").addClass("active willAddUltraGift");
                    }      
                        }
                    }
                });
            }
        }
        else {
            localStorage.removeItem('cartGiftItems');
            localStorage.removeItem('giftItemClasses');
        }

    }
    appendItemsOnLoad();

    function clearCartOnReturnToCheckout(){
         let checkout = localStorage.getItem('checkout');
            if (checkout === 'true') {
                localStorage.removeItem('checkout');
                window.location.href = "/cart/clear";
            }
    }
    clearCartOnReturnToCheckout();
});

document.addEventListener("variant:changed", function (event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    console.log("variant event:", event.detail);

    try {
        setTimeout(function () {
            document.querySelector('.btn.klaviyo-bis-trigger').style.display = 'none';
        }, 10);

    }
    catch (e) { }

    //show/hide Add to Cart & Klaviyo Notify Me
    var productForm = $('#product_form_' + event.detail.product.id)
    if (variant.available) {
        productForm.find(':submit').html('<span>Add to bag</span>');
        //productForm.find('.klaviyo-bis-trigger').hide();
    }
    else {
        var cartButton = productForm.find('.ProductForm__AddToCart');
        console.log('cartButton:', cartButton);
        cartButton.html('<a class="klaviyo-bis-trigger" href="#">Notify Me When Available</a>');
        cartButton.removeAttr('disabled').removeAttr('type').attr('type', 'button');
        //productForm.find('.klaviyo-bis-trigger').show();
    }

});


function LoadLibrary(liburl, callback) {
    var jscript = document.createElement("script");
    jscript.type = 'text/javascript';
    jscript.src = liburl;
    //for IE type browsers
    if (jscript.readyState) {
        jscript.onreadystatechange = function () {
            if (jscript.readyState == "loaded" || jscript.readyState == "complete") {
                jscript.onreadystatechange = null;
                callback();
            }
        };
    } else {
        jscript.onload = function () {
            callback();
        };
    }
    document.getElementsByTagName("head")[0].appendChild(jscript);
}

if (!window.jQuery) {
    LoadLibrary('https://code.jquery.com/jquery-3.3.1.min.js',
        function () {
            $(document).ready(function () {
                $(".Product__Slideshow .Product__SlideItem").clone(true).appendTo(".slide-placeholder");
            });



            console.log('jQuery loaded');
        }
    );
}



function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function () { defer(method) }, 50);
    }
}

defer(function () {

    window.VIG = window.VIG || {};
    VIG.loaded = false;
    VIG.VariantChangeCallback = function () {
        var visible_ids = $('.slide-placeholder img:visible').map(function () {
            return $(this).data('image-id');
        }).get();
        $(".flickity-page-dots button").hide();
        var visible_index = 0;
        var slidesToAdd = [];

        visible_ids.forEach(function (element) {
            slidesToAdd.push($('.slide-placeholder [data-image-id=' + element + ']').closest('.Product__SlideItem'));
        });

        var $sliders = $('.Product__Slideshow.flickity-enabled');

        $sliders.each(function () {

            var $slider = $(this);
            var $sliderInstance = Flickity.data(this);
            if ($sliderInstance != undefined) {

                $sliderInstance.remove($('.Product__Slideshow .Product__SlideItem'));
                slidesToAdd.forEach(function (element) {
                    $sliderInstance.append(element.clone(true));
                    visible_index = element.attr('data-image-media-position');
                    $(".flickity-page-dots button[data-index='" + visible_index + "']").show();
                });
            }
            else {
                console.log('slider instance undefined');
            }
        });

        $(".flickity-page-dots button[data-index]:visible").first().addClass('is-selected');
        window.scrollTo(0, 0);

    }

});/*FIXED BY VIP:2021-03-22 21:01:12 UTC*/


function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};


// product quick add and bundle add to cart

$(document).on("click", " [data-action='decrease-quantity-custom']", function () {
    var current = parseInt($(this).next().val());
    $(this).next().val(Math.max(current - 1, 1));
});
$(document).on("click", "[data-action='increase-quantity-custom']", function () {
    var current = parseInt($(this).prev().val());
    $(this).prev().val(current + 1);
});

$(document).on("click", ".product-grid-form [data-action='decrease-quantity-bundle_item']", function () {
    var current = parseInt($(this).next().val());
    var new_qty = Math.max(current - 1, 0);
    $(this).next().val(new_qty);
    if (new_qty == 0) {
        var item = $(this).parents('.product_item_wrap');
        item.addClass('removed');
        item.find('.sets_items').prop("checked", false);
    }
});

$(document).on("click", ".product-grid-form [data-action='increase-quantity-bundle_item']", function () {
    var current = parseInt($(this).prev().val());
    $(this).prev().val(current + 1);
    if (current == 0) {
        var item = $(this).parents('.product_item_wrap');
        item.removeClass('removed');
        item.find('.sets_items').prop("checked", true);
    }
});

$(document).on("click", ".bundle_set_qty_parent_all .bundle_set_qty_decrease", function () {
    var current = parseInt($(this).next().val());
    if (current > 1) {
        var new_qty = Math.max(current - 1, 0);
        $(this).next().val(new_qty);
        $('.product-grid-form input.QuantitySelector__CurrentQuantity').val(new_qty);
    }
});

$(document).on("click", ".bundle_set_qty_parent_all .bundle_set_qty_increase", function () {
    var current = parseInt($(this).prev().val());
    $(this).prev().val(current + 1);
    $('.product-grid-form input.QuantitySelector__CurrentQuantity').val(current + 1);
    $('.Product_bundled_with .ProductListWrapper .product_item_wrap').removeClass('removed');
});

$(document).on("click", ".ProductGrid__AddToCart", function () {
    var vid = $(this).attr("data-id");
    var dataProperty = $(this).attr("data-Property");
    let btn = $(this);
    var qty = $(this).parent().find(".QuantitySelector__CurrentQuantity").val();
    console.log(vid, qty);
    console.log(dataProperty);
    btn.addClass("adding");
    var requestData = {
        quantity: qty,
        id: vid,
    };
    // Conditionally add _Engraving property if dataProperty exists
    if (dataProperty) {
        requestData.properties = {
            "_Engraving": dataProperty
        };
    }
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: requestData,
        dataType: "json",
        success: function (cart) {
            fetch('/cart?view=drawer&timestamp=', {
                credentials: 'same-origin',
                method: 'GET',
                dataType: 'html',
            }).then(function (content) {
                content.text().then(function (html) {
                    var tempElement = document.createElement('div');
                    tempElement.innerHTML = html;

                    $("#sidebar-cart").find('.Cart').replaceWith(tempElement.querySelector('.Cart'));
                    $("#sidebar-cart").attr("aria-hidden", false);
                    if (tempElement.querySelector('#count-cart')) {
                        $('.Drawer__Header #count-cart').html(tempElement.querySelector('#count-cart').innerHTML);
                    }
                    $(".PageOverlay").addClass("is-visible");
                    $("#sidebar-cart").attr("tabindex", "-1");
                    $("html").addClass("no-scroll");
                    btn.removeClass("adding");
                });
            });
        },
        error: function (XMLHttpRequest, textStatus) {
            btn.removeClass("adding");
            var response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;
        },
    });
});
// $(document).on("click", ".Drawer__Close.Icon-Wrapper--clickable" ,closeCartDrawer());

$(document).on("click", ".PageOverlay.is-visible", function () {
    $("#sidebar-cart").attr("aria-hidden", true);
    $("#sidebar-cart").removeAttr("tabindex");
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass("no-scroll");
});

$(".Drawer__Close.Icon-Wrapper--clickable").on("click", function () {
    $("#sidebar-cart").attr("aria-hidden", true);
    $("#sidebar-cart").removeAttr("tabindex");
    $(".PageOverlay").removeClass("is-visible");
    $("html").removeClass("no-scroll");
});

$(".ProductForm__Bundled_with .SectionHeader").on('click', function () {
    if ($(this).siblings('.ProductListWrapper').css('display') == 'none') {
        $(this).parent().addClass('tab--open')
        $(this).siblings('.ProductListWrapper').slideDown()
    } else {
        $(this).siblings('.ProductListWrapper').slideUp(() => {
            $(this).parent().removeClass('tab--open')
        })
    }
});

$(document).on("click", ".Product_bundled_with .product_item_wrap .remove_item", function () {
    var item = $(this).parents('.product_item_wrap');
    item.addClass('removed');
    item.find('.sets_items').prop("checked", false);
    item.find(".QuantitySelector__CurrentQuantity").val("0");
});

$(document).on("click", ".mobile-overlay", function () {
    $(this).hide();
    $(this).next().addClass("show");
})

$(document).on("click", ".btn-add-sets-tocart", function () {
    var btn = $(this);
    btn.addClass("adding-to-cart");
    var products = [];
    $(".sets_items").each(function () {
        var qty = $(this).parent().find(".QuantitySelector__CurrentQuantity").val();
        if (qty > 0) {
            products.push({
                id: $(this).val(),
                quantity: qty
            });
        }
    });
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            items: products
        },
        dataType: 'json',
        success: function (cart) {
            btn.removeClass("adding-to-cart");
            fetch('/cart?view=drawer&timestamp=', {
                credentials: 'same-origin',
                method: 'GET',
                dataType: 'html',
            }).then(function (content) {
                content.text().then(function (html) {
                    console.log(typeof html);
                    var tempElement = document.createElement('div');
                    tempElement.innerHTML = html;
                    $("#sidebar-cart").find('.Cart').replaceWith(tempElement.querySelector('.Cart'));
                    $("#sidebar-cart").attr("aria-hidden", false);
                    $(".PageOverlay").addClass("is-visible");
                    $("#sidebar-cart").attr("tabindex", "-1");
                    $("html").addClass("no-scroll");
                });
            });
        },
        error: function (XMLHttpRequest, textStatus) {
            btn.removeClass("adding-to-cart");
            var response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;
        },
    });
});

// add aria-label to flickity slider pagination
$(function () {
    $('.flickity-page-dots .dot').each(function (i, dots) {
        $(dots).attr('aria-label', i);
    });
})


$('.HorizontalList__Item').hover(
    function () {
        $(this).children(".MegaMenu").addClass("activeOne").attr("aria-hidden", "false");
        $(this).addClass("is-expanded");
    },
    function () {
        $(this).children(".MegaMenu").removeClass("activeOne").attr("aria-hidden", "true");
        $(this).removeClass("is-expanded");
    }
);

window.addEventListener('resize', function () {
    var headerMainNav = document.querySelector('.Header__MainNav');
    var headerWrapper = document.querySelector('.Header__Wrapper');
    var headerLogo = document.querySelector('.Header__Logo');;
    var secondaryNav = document.querySelector('.Header__SecondaryNav');

    if (window.innerWidth >= 1140) {
        headerMainNav.classList.add('Lapover');
        headerWrapper.classList.add('header_m');
        headerLogo.classList.add('logo_m');
        secondaryNav.classList.add('remove_dummy');
    } else {
        headerMainNav.classList.remove('Lapover');
        headerWrapper.classList.remove('header_m');
        headerLogo.classList.remove('logo_m');
        secondaryNav.classList.remove('remove_dummy');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const announcement = document.getElementById('section-announcement');
    const headerWrapper = document.querySelector('.Header__Wrapper');

    if (announcement) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 0) {
                announcement.classList.add('sticked');
                headerWrapper.classList.add('padded');
            } else {
                announcement.classList.remove('sticked');
                headerWrapper.classList.remove('padded');
            }
        });
    }
});
